module.exports = __webpack_public_path__ + "img/back.8232faf7.png";